import { Component, input } from '@angular/core';
import { CURRENCIES } from '@webapp/payments';
import { formatCurrency } from '../../../helpers/utils';
import { ICoverage } from '@webapp/payments';

@Component({
	selector: 'app-coverage-price',
	imports: [],
	templateUrl: './coverage-price.component.html',
	styleUrl: './coverage-price.component.scss',
})
export class CoveragePriceComponent {
	coverage = input<ICoverage>();
	currency = input<string>();

	getMainValue() {
		const price = this.coverage()?.prices?.find((item) => item.currency === this.currency());
		const value = (price?.subscription) ? price.subscription : price?.premium;
		return formatCurrency(value, price?.currency ?? CURRENCIES.ARS);
	}

	getValue() {
		const value = this.coverage()?.prices?.find((item) => item.currency !== this.currency());
		return formatCurrency(value?.premium, value?.currency ?? CURRENCIES.ARS);
	}

}
